import * as React from 'react';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { Konkurrence } from '../../models/Konkurrence';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import KonkurrenceEdit from './KonkurrenceEdit';
import { Redirect } from 'react-router-dom';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import NotificationData from '../../uiComponents/layout/NotificationData';
import { Opgavepakke } from '../../models/Opgavepakke';
import { Spinner } from '../../uiComponents/Spinner';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import { getSkoleaarFromDate } from '../../models/SkoleAar';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { isNullOrUndefined } from '../../infrastructure/ValidationHelper';
import { Kommune } from '../../models/Kommune';
import HelperMethods from '../../infrastructure/HelperMethods';
import { EksternBruger } from '../../models/EksternBruger';

interface KonkurrenceContainerProps extends RouteComponentProps<any> {
}

interface KonkurrenceContainerState {
    validationResult?: ValidationResult;
    konkurrence?: Konkurrence;
    kommuner: Kommune[];
    opgavepakker?: Opgavepakke[];
    eksterne: EksternBruger[];
    isSaved: boolean;
    isNew: boolean;
    isSubmitting: boolean;
    konkurrenceEditorState: EditorState;
}

class KonkurrenceContainer extends React.Component<KonkurrenceContainerProps, KonkurrenceContainerState> {
    constructor(props: KonkurrenceContainerProps) {
        super(props);

        this.state = {
            validationResult: new ValidationResult(), 
            konkurrence: undefined, 
            kommuner: [],
            eksterne: [], 
            opgavepakker: undefined,
            isSaved: false,
            isNew: true, 
            isSubmitting: false,
            konkurrenceEditorState: EditorState.createEmpty()
        };
        
        this.onKonkurrenceChanged = this.onKonkurrenceChanged.bind(this);
        this.onBeskrivelseChanged = this.onBeskrivelseChanged.bind(this);
        this.onKonkurrenceSave = this.onKonkurrenceSave.bind(this);
        this.onKonkurrenceDelete = this.onKonkurrenceDelete.bind(this);
        this.onFileUpload = this.onFileUpload.bind(this);
        this.onKonkurrenceSaved = this.onKonkurrenceSaved.bind(this);
        this.filterOpgavepakker = this.filterOpgavepakker.bind(this);
    }

    componentDidMount() {
        const apiCaller = createApiCaller();
        apiCaller.getOpgavepakker().then(response =>
            this.setState({ opgavepakker: response })
        );

        apiCaller.getKommuner().then(response => {            
            let kommunerSorted = HelperMethods.sortKommuneByNavn(response);            
            this.setState({ kommuner: kommunerSorted });
        });

        apiCaller.getEksterneBrugere().then(response => {
            this.setState({ eksterne: response });
        });
        
        var param = this.props.match.params.id;
        this.setState({ isNew: param === 'ny' ? true : false });

        if (param === 'ny') {
            const newKonkurrence = new Konkurrence();
            newKonkurrence.opgavepakker = [];
            newKonkurrence.eksterne = [];
            this.setState({ konkurrence: newKonkurrence });
            this.setInitialEditorState(newKonkurrence);
        } else {
            var konkurrencePromis = apiCaller.getKonkurrence(param);
            konkurrencePromis.then((json: any) => {
                this.setState({ konkurrence: json });
                this.setInitialEditorState(json);
            });
        }
    }

    onKonkurrenceChanged(fieldName: string, value: any) {
        const konkurrence = this.getKonkurrence();
        konkurrence[fieldName] = value;
        if (fieldName === 'opgavePakkeIds' && this.state.opgavepakker !== undefined) {
            const opgavepakkeIds = value as string[];
            const opgavepakkerValgt = this.state.opgavepakker.filter(o => opgavepakkeIds.indexOf(o.id) > -1);
            konkurrence['opgavepakker'] = opgavepakkerValgt;
        } else if (fieldName === 'eksternIds' && this.state.eksterne !== undefined) {
            const valgteEksterne = value.map((v: any) => {
                const ekstern = new EksternBruger;
                ekstern.email = v.value;
                ekstern.id = v.key;

                return ekstern;
            });

            konkurrence['eksterne'] = valgteEksterne;
        }
        this.setState({ konkurrence: konkurrence });
    }

    onBeskrivelseChanged(editorState: EditorState) {
        this.setState({ konkurrenceEditorState: editorState });
        let content = convertToRaw(editorState.getCurrentContent());
        const konkurrence = this.getKonkurrence();
        konkurrence.beskrivelse = JSON.stringify(content);
        this.setState({ konkurrence: konkurrence, konkurrenceEditorState: editorState });
    }

    onKonkurrenceSave() {
        this.setState({isSubmitting: true});
        let param = this.props.match.params.id;
        let notificationMessage = 'Konkurrencen er blevet ';
        const konkurrence = this.getKonkurrence();
        if (param === 'ny') {            
            let createKonkurrencePromise = createApiCaller().createKonkurrence(konkurrence);
            createKonkurrencePromise.then((validationResult: ValidationResult) => {
                this.onKonkurrenceSaved(validationResult, notificationMessage + 'oprettet');
            });
        } else {
            let updateKonkurrencePromise = createApiCaller().updateKonkurrence(konkurrence);
            updateKonkurrencePromise.then((validationResult: ValidationResult) => {
                this.onKonkurrenceSaved(validationResult, notificationMessage + 'opdateret');
            });
        }
    }

    onKonkurrenceSaved(validationResult: ValidationResult, notificationMessage: string) {
        this.setState({ validationResult: validationResult, isSaved: validationResult.isValid ? true : false, isSubmitting: false });
        if (validationResult.isValid) {
            NotificationQueue.push(new NotificationData(notificationMessage, '', 'success'));
        }
    }

    onKonkurrenceDelete() {
        let konkurrence = this.getKonkurrence();
        let self = this;
        let deleteKonkurrencePromise = createApiCaller().deleteKonkurrence(konkurrence.id);
        deleteKonkurrencePromise.then(function () {
            self.setState({ isSaved: true });
        });
    }

    onFileUpload(formData: FormData) {
        this.setState({ isSubmitting: true });
        let self = this;
        const konkurrence = this.getKonkurrence();
        createApiCaller().uploadImage(formData).then(fileId => {
            konkurrence.billedId = fileId;
            self.setState({ konkurrence: konkurrence, isSubmitting: false });
        });
    }

    getKonkurrence(): Konkurrence {
        const k = this.state.konkurrence;
        if (k === undefined) {
            throw new Error('konkurrence er undefined');
        }
        return k;
    }

    filterOpgavepakker(opgavepakker: Opgavepakke[], konkurrence?: Konkurrence): Opgavepakke[] {
        if (konkurrence === undefined) {
            return opgavepakker;
        }
        const skoleaar = getSkoleaarFromDate(konkurrence.startdato);
        return opgavepakker
            .filter(o => Number(o.skoleaar) === Number(skoleaar));
    }

    setInitialEditorState (konkurrence: Konkurrence) {
        let beskrivelse = konkurrence.beskrivelse;
        let editorState = EditorState.createEmpty();
        if (!isNullOrUndefined(beskrivelse)) {
            let content = convertFromRaw(JSON.parse(beskrivelse));
            editorState = EditorState.createWithContent(content);
        }
        this.setState({
            konkurrenceEditorState:  editorState
        });
    }

    render() {
        if (this.state.isSaved === false) {
            if ((this.state.konkurrence === undefined && !this.state.isNew) || this.state.opgavepakker === undefined) {
                return <Spinner />;
            } else {
                return (
                    <PageWrapper>
                        <PageTitle title={'Konkurrencer'} />
                        <ContentWrapper>
                            <KonkurrenceEdit
                                konkurrence={this.state.konkurrence === undefined ? new Konkurrence : this.state.konkurrence}
                                errorMessages={this.state.validationResult ? this.state.validationResult.errorMessages : []}
                                onKonkurrenceChanged={this.onKonkurrenceChanged}
                                onBeskrivelseChanged={this.onBeskrivelseChanged}
                                beskrivelseEditorState={this.state.konkurrenceEditorState}
                                onKonkurrenceSave={this.onKonkurrenceSave}
                                onKonkurrenceDelete={this.onKonkurrenceDelete}
                                onFileUpload={this.onFileUpload}
                                kommuner={this.state.kommuner}
                                isNew={this.state.isNew}
                                isSubmitting={this.state.isSubmitting}
                                opgavepakker={this.filterOpgavepakker(this.state.opgavepakker, this.state.konkurrence)}
                                eksterne={this.state.eksterne}
                                location={this.props.location}
                                match={this.props.match}
                                history={this.props.history}
                            />
                        </ContentWrapper>
                    </PageWrapper>
                );
            }
        } else {
            return (
                <Redirect to='/konkurrencer' />
            );
        }
    }
}

export default KonkurrenceContainer;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceContainer.tsx